import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const Grid4 = t0 => {
  const $ = _c(6);
  const {
    width: t1,
    height: t2,
    fill: t3
  } = t0;
  const width = t1 === undefined ? "10" : t1;
  const height = t2 === undefined ? "10" : t2;
  const fill = t3 === undefined ? "#424242" : t3;
  let t4;
  if ($[0] !== fill) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M13 0V13H0V0H13ZM11.75 1.25H1.25V11.75H11.75V1.25ZM13 16V29H0V16H13ZM11.75 17.25H1.25V27.75H11.75V17.25ZM29 13V0H16V13H29ZM17.25 1.25H27.75V11.75H17.25V1.25ZM29 16V29H16V16H29ZM27.75 17.25H17.25V27.75H27.75V17.25Z" fill={fill} />;
    $[0] = fill;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== height || $[3] !== t4 || $[4] !== width) {
    t5 = <svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">{t4}</svg>;
    $[2] = height;
    $[3] = t4;
    $[4] = width;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
Grid4.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default Grid4;